import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { InputSelect } from '@/components';
import type { FilterState } from '@/features/filterSlice';
import type { TagField } from '@/features/types';

export const TagsFilter = (props: {
  control: Control<FilterState>;
  data: TagField[];
}) => {
  const tags = props.data.map((i) => ({
    value: i.id.toString(),
    label: i.name,
  }));

  return (
    <Controller
      control={props.control}
      name="tags"
      render={({ field: { onChange, onBlur, value } }) => {
        return (
          <InputSelect
            isMulti
            label="Tags"
            placeholder="All tags"
            options={tags}
            onChange={onChange}
            onBlur={onBlur}
            value={tags.filter((c) => value.includes(c.value))}
            maxMenuHeight={150}
          />
        );
      }}
    />
  );
};
